var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-container',{attrs:{"pt-0":"","pb-0":"","mt-0":"","ma-0":_vm.smAndDown,"pa-0":_vm.smAndDown}},[_c('v-layout',{staticClass:"hero-section",attrs:{"wrap":_vm.smAndDown}},[_c('HeroLeft'),_c('HeroRight')],1)],1),_c('footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }